import configureReactRailsContext from 'Utils/configureReactRailsContext'
import loadLocaleBundle from 'Translations/loadLocaleBundle'

// Start fetching the active locale's translations at script-eval time so the
// bundle is registered before components hydrate (no English flash on non-EN
// pages). Resolves immediately on English pages.
const localeReady = loadLocaleBundle()

window.addEventListener("load", () => {
  localeReady.then(() => {
    const ReactRailsUJS = require("react_ujs")
    // this approach requires all components inside NewHomepage pod.
    // if evaluation time for script becomes too long it can be replaced with
    // a different folder structure and require call for each component separately.
    const context = require.context(
      'Pods',
      true,
      // eslint-disable-next-line max-len
      /\/(NewHomepage|(Shared\/(TrustedBrands|TrendingModelsSection|ValueProposition|PrintModels|SubscriptionPromoSection)))\/(?!.*(?:test|story).*$).*$/
    )

    configureReactRailsContext(ReactRailsUJS, context)

    ReactRailsUJS.mountComponents("#home-elements")
  })
})
